import * as C from '../constants';
import * as ActionCreators from '../actions/ActionCreators';
import { actionEqual } from './utils';

const defaultState: BuyShopItemState = {
  buyState: C.BUY_SHOP_ITEM_STATE.DEFAULT,
  lastSelectedShopItemId: -1,
};

export const getBuyShopItemState = (state: BuyShopItemState) => state.buyState;

export const getLastSelectedShopItemId = (state: BuyShopItemState) =>
  state.lastSelectedShopItemId;

function handleSelectShopItem(
  state: BuyShopItemState,
  action: ShopItemSelect
): BuyShopItemState {
  return { ...state, lastSelectedShopItemId: action.payload.shopItemId };
}

export default function buyShopItem(
  state: BuyShopItemState = defaultState,
  action: Action
): BuyShopItemState {
  if (actionEqual(action, ActionCreators.updateBuyShopItemState)) {
    return { ...state, buyState: action.payload.nextState };
  }
  switch (action.type) {
    case C.ACTION_TYPES.SHOP_ITEM_SELECT:
      return handleSelectShopItem(state, action as ShopItemSelect);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/buyShopItem.ts